
  import games from '~/mixins/common/pages/games'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'
  export default {
    name: 'GameMenu',
    mixins: [games, cms, playGames],
    methods: {}
  }
